import { render, staticRenderFns } from "./ConnectAi.vue?vue&type=template&id=65d74306&scoped=true"
import script from "./ConnectAi.vue?vue&type=script&lang=js"
export * from "./ConnectAi.vue?vue&type=script&lang=js"
import style0 from "./ConnectAi.vue?vue&type=style&index=0&id=65d74306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d74306",
  null
  
)

export default component.exports